<div class="forgot-password">
  <img [src]="mercuryLogoPath" class="mercury-logo" alt="Mercury Logo" />
  <div class="col-12 body-medium text-tertiary subtitle-gap p-0">
    Recover Account
  </div>
  <div class="col-12 jumbo-medium text-primary title-gap p-0">
    Forgot your Password
  </div>
  <div class="col-12 body-medium text-tertiary paragraph-gap p-0">
    A reset password will be sent to the email address
  </div>
  <form class="col-12 p-0" [formGroup]="form">
    <div class="col-12 p-0" style="margin-bottom: 48px">
      <div class="form-group">
        <div class="mb-1 field-label-medium text-tertiary">
          <label for="emailInput">Email</label>
        </div>
        <div class="form-control p-fluid">
          <input
            class="w-full"
            data-hj-allow
            pInputText
            formControlName="email"
            type="email"
            id="emailInput"
            aria-describedby="emailHelp"
            placeholder="User Email"
          />

          <me-form-validation-message label="Email" controlName="email">
          </me-form-validation-message>
        </div>
      </div>
    </div>
    <div class="grid m-0 p-0">
      <div class="col-6 p-0" style="padding-right: 0.5rem !important">
        <button
          pButton
          type="button"
          class="p-button-secondary w-full button-text-medium"
          routerLink="/login"
        >
          <span pButtonLabel>Back to Login</span>
        </button>
      </div>
      <div class="col-6 p-0">
        <button
          pButton
          type="button"
          class="p-button-primary w-full button-text-medium"
          [disabled]="
            email.invalid ||
            (enableRecaptchaFlag && useTurnstile && !verifiedSuccessfully)
          "
          (click)="
            enableRecaptchaFlag && !useTurnstile
              ? submitRequestWithCaptcha()
              : sendResetPasswordRequest()
          "
        >
          <span pButtonLabel>Send Reset Link</span>
        </button>
      </div>
    </div>
  </form>
</div>

@if (enableRecaptchaFlag) {
  @if (useTurnstile) {
    <div
      #turnstileRef
      class="turnstile-container flex justify-content-center mt-3"
    ></div>
  } @else {
    <re-captcha
      #captchaRef
      (resolved)="resolved($event)"
      [siteKey]="captchaPublicSiteKey"
      size="invisible"
    ></re-captcha>
  }
}
